import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';

// Modal séparé
import EvaluationModal from "./partials/EvaluationModal";

// Modal séparé
import EvaluationForm from "./partials/EvaluationForm";

import {
    getEvaluations as onGetEvaluations,
    addNewEvaluation as onAddNewEvaluation,
    updateEvaluation as onUpdateEvaluation,
    deleteEvaluation as onDeleteEvaluation,

    getSemesters as onGetSemesters,
    getCourseUnits as onGetCourseUnits,
    //getSessions as onGetSessions,
    resetEvaluationLastActionSuccess as OnResetEvaluationLastActionSuccess,
   

    
} from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { useNavigate } from "react-router-dom";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const Evaluation = () => {

    //meta title
    document.title = "Évaluations | CinzanEdu";

    const dispatch = useDispatch();
    
    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [evaluation, setEvaluation] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false);
    const [loadingState, setLoadingState] = useState(true);

    const navigate = useNavigate();

    
    // Selector Evaluation
    const EvaluationProperties = createSelector(
        (state) => state.evaluationReducer, 
        (evaluationReducer) => ({
            evaluations: evaluationReducer.evaluations,
            loading: evaluationReducer.loading,
            lastActionSuccess: evaluationReducer.lastActionSuccess
        })
    );

    const {evaluations, loading, lastActionSuccess} = useSelector(EvaluationProperties);

    const [isLoading, setLoading] = useState(loading)


    // Selector Semester
    const SemesterProperties = createSelector(
        (state) => state.semesterReducer, 
        (semesterReducer) => ({
            semesters: semesterReducer.semesters,
            loading: semesterReducer.loading
        })
    );

    const {semesters} = useSelector(SemesterProperties);

    // Selector Course Unit
    const CourseUnitProperties = createSelector(
        (state) => state.courseUnitReducer, 
        (courseUnitReducer) => ({
            courseUnits: courseUnitReducer.courseUnits,
            loading: courseUnitReducer.loading
        })
    );

    const {courseUnits} = useSelector(CourseUnitProperties);





    console.log("EVALUATIONS: ", evaluations);

    // Chargement initial des données
    useEffect(() => {
        if (!evaluations.length) dispatch(onGetEvaluations());
        if (!semesters.length) dispatch(onGetSemesters());
        if (!courseUnits.length) dispatch(onGetCourseUnits());
        setLoadingState(loading);
    }, [dispatch, evaluations.length, semesters.length, courseUnits.length, loading]);

    // Ferme le modal en cas de success
    useEffect(() => {
        
        if (lastActionSuccess && modal) {
            toggle();
            setEvaluation(null);
            dispatch(OnResetEvaluationLastActionSuccess()); // action qui remet à false
        }
    }, [lastActionSuccess, modal, dispatch]);

    // Toggle modal
    const toggle = () => {
        setModal(!modal);
        if (modal) setEvaluation(null);
    };

    // Créer nouvelle structure
    const onClickNewEvaluationForModal = () => {
        setIsEdit(false);
        setEvaluation(null);
        toggle();
    };
    
      // Edit structure
      const handleEvaluationClickOld = (evaluation) => {
        setEvaluation(evaluation);
        setIsEdit(true);
        toggle();
        dispatch(OnResetEvaluationLastActionSuccess()); // reset pour l’édition
      };
    
      // Delete structure
      const onClickDelete = (evaluation) => {
        setEvaluation(evaluation);
        setDeleteModal(true);
      };
      const handleDeleteEvaluation = () => {
        if (evaluation?.id) {
          dispatch(onDeleteEvaluation(evaluation));
          setDeleteModal(false);
        }
      };

      // Remplacer cette fonction
        const onClickNewEvaluation = () => {
            navigate("/evaluations/new");
        };

        const handleEvaluationClick = (evaluation) => {
    // navigation vers la page édition avec l’UUID de l’évaluation
    navigate(`/evaluations/${evaluation.uuid}/edit`);
};



    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Titre",
                accessorKey: "title",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Type",
                accessorKey: "evaluation_type.title",
                enableColumnFilter: false,
                enableSorting: true,
            },
             {
                header: "Date début",
                accessorKey: "start_date",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Date fin",
                accessorKey: "end_date",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Semestres",
                accessorKey: "semesters",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    const semesters = cellProps.row.original.semesters;

                    // Si aucun semestre n'est associé ou si la relation n'est pas chargée
                    if (!semesters || semesters.length === 0) {
                        return <span className="text-muted font-size-12">Aucun</span>;
                    }

                    return (
                        <div className="d-flex flex-wrap gap-1">
                            {semesters.map((semester) => (
                                <Badge 
                                    key={semester.id} 
                                    className="bg-light text-primary border border-primary-subtle"
                                >
                                    {semester.code}
                                </Badge>
                            ))}
                        </div>
                    );
                }
            },
            {
                header: "Session",
                accessorKey: "session.title",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Statut",
                accessorKey: "status",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    const status = cellProps.row.original.status;
                    switch (status) {
                        case "CREATED":
                            return <Badge className="bg-info">Créée</Badge>;
                        case "GRADING":
                            return <Badge className="bg-warning text-dark">En cours de saisie</Badge>;
                        case "GRADING_FINISHED":
                            return <Badge className="bg-primary">Saisie terminée</Badge>;
                        case "PROCLAIMED":
                            return <Badge className="bg-success">Proclamée</Badge>;
                        case "LOCKED":
                            return <Badge className="bg-danger">Verrouillée</Badge>;
                        case "OPEN":
                            return <Badge className="bg-success">Ouverte</Badge>;
                        case "CLOSED":
                            return <Badge className="bg-danger">Fermée</Badge>;
                        default:
                            return <Badge className="bg-secondary">{status}</Badge>;
                    }
                }
            },
            {
                header: 'Actions',
                accessorKey: 'action',
                enableColumnFilter: false,
                enableSorting: true,
                    cell: (cellProps) => {
                      return (
                        <UncontrolledDropdown>
                          <DropdownToggle tag="a" href="#" className="card-drop">
                            <i className="mdi mdi-dots-horizontal font-size-18" />
                          </DropdownToggle>
                          <DropdownMenu className="dropdown-menu-end">
                            <DropdownItem onClick={() => handleEvaluationClick(cellProps.row.original)}>
                                <i className="mdi mdi-pencil font-size-16 text-success me-1" />Modifier
                            </DropdownItem>


                            <DropdownItem href="#!" onClick={() => navigate(`/anonymous-exam-records/evaluation/${cellProps.row.original.uuid}`)}>
                                <i className="bx bx-id-card font-size-16 text-success me-1" />Fiches anonymes
                            </DropdownItem>

                            <DropdownItem href="#!" onClick={() => onClickDelete(cellProps.row.original)}>
                                <i className="mdi mdi-trash-can font-size-16 text-danger me-1" />Supprimer
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      );
                    }
                },
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteEvaluation}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Évaluations" breadcrumbItem="Liste des évaluations" />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 

                                                <div className="flex-shrink-0">
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary me-1"
                                                        onClick={() => navigate("/evaluations/new")}
                                                    >
                                                        Ajouter une évaluation
                                                    </button>
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={evaluations || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={true}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }

                    {/* Modal séparé */}
                    <EvaluationModal
                        modal={modal}
                        toggle={toggle}
                        isEdit={isEdit}
                        evaluation={evaluation}
                        courseUnits={courseUnits}
                        semesters={semesters}
                        onSubmit={(payload) => {
                        if (isEdit) {
                            dispatch(onUpdateEvaluation(payload));
                        } else {
                            dispatch(onAddNewEvaluation(payload));
                        }
                        }}
                    />
                    

                </div>
            </div>
            <ToastContainer />
        </React.Fragment>
    );
}


export default Evaluation;